import utilits from '@/assets/utilits/request.js'
export default {
  namespaced: true,
  state: {},
  mutations: {},

  actions: {
    getallresource ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getallresource',
        obj,
        callback
      )
    },
    getMachineList ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/getmachinelist ',
        obj,
        callback
      )
    },
    addphymachine ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/addphymachine ',
        obj,
        callback
      )
    },
    getResourceInfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/getmacinfo',
        obj,
        callback
      )
    },
    getaccountinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getaccountinfo',
        obj,
        callback
      )
    },
    setMacOwner ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/setmacowner',
        obj,
        callback
      )
    },
    setMacAdmin ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/setmacadmin',
        obj,
        callback
      )
    },
    optecs ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/optecs', obj, callback)
    },
    getregions ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getregions',
        obj,
        callback
      )
    },
    getzones ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getzones',
        obj,
        callback
      )
    },
    setaccountinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/setaccountinfo',
        obj,
        callback
      )
    },
    getcloudvender ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getcloudvender',
        obj,
        callback
      )
    },
    gettypes ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/gettypes',
        obj,
        callback
      )
    },
    getimages ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getimages',
        obj,
        callback
      )
    },
    exportresourcetoexecl ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/exportresourcetoexecl',
        obj,
        callback
      )
    },
    getsegs ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.get, '/cmpapi/getsegs', obj, callback)
    },
    getvpcs ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.get, '/cmpapi/getvpcs', obj, callback)
    },
    getswitchs ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getswitchs',
        obj,
        callback
      )
    },
    getopenstacknetwork ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getopenstacknetwork',
        obj,
        callback
      )
    },
    getdisktype ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getdisktype',
        obj,
        callback
      )
    },
    getbillingmethod ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getbillingmethod',
        obj,
        callback
      )
    },
    createecs ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/createecs',
        obj,
        callback
      )
    },
    createseg ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/createseg',
        obj,
        callback
      )
    },
    setecsdesc ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/setecsdesc',
        obj,
        callback
      )
    },
    sethidsstatus ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/sethidsstatus',
        obj,
        callback
      )
    },
    setphybillingrule ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/setphybillingrule',
        obj,
        callback
      )
    },
    getselfkeys ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getselfkeys',
        obj,
        callback
      )
    },
    setecsselfkeys ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/setecsselfkeys',
        obj,
        callback
      )
    },
    exporthidsinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/exporthidsinfo',
        obj,
        callback
      )
    },
    downloadfile ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/downloadfile',
        obj,
        callback
      )
    },
    // /cmpapi/exporthidsinfo?macidstr=1505812779502669824&mactype=hidsport
    downloadfiles ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/exporthidsinfo',
        obj,
        callback
      )
    },
    // 获取用户是否为资源池管理员
    checkresourceadmin ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/checkresourceadmin',
        obj,
        callback
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/resources.js